import ProgressCircle from './components/ProgressCircle';
import { getColor } from './lib/getColor';

/**
 * @param {import('./lib/propTypes').ProgressProps} props
 */

const Progress = ({ percentage = 0, className }) => {
  const clampedPercentage = Math.max(0, Math.min(100, percentage));
  const tone = getColor(clampedPercentage);

  return (
    <ProgressCircle
      percentage={clampedPercentage}
      tone={tone}
      size={28}
      className={className}
      ariaLabel={`${clampedPercentage}% complete`}
    />
  );
};

export default Progress;
